import Command from './Command';

import IllustrationResource from '../resources/IllustrationResource';
import SoundResource from '../resources/SoundResource';

import IllustrationCommandOptions from '../../value_objects/command_options/IllustrationCommandOptions';
import SoundEffectCommandOptions from '../../value_objects/command_options/SoundEffectCommandOptions';

export default class IllustrationShowCommand extends Command {
  constructor(
    public id: number,
    public sceneId: number,
    public illustration: IllustrationResource,
    public sound: SoundResource | undefined | null,
    public options: IllustrationCommandOptions,
    public soundOptions: SoundEffectCommandOptions,
  ) {
    super(id, sceneId);
  }

  public getAudioUrl(): string | null {
    if (!this.sound) {
      return null;
    }
    return this.sound.getAudioUrl({
      satrtTime: this.soundOptions.startTime,
      endTime: this.soundOptions.endTime,
    });
  }
}
